export enum CalendarView {
    Daily = 'day',
    Weekly = 'week',
    Monthly = 'month'
}

export const UNASSIGNED_STAFF_ID = 0;
